import {AppState} from "../state";
import {GDPR, GDPRAction} from "../state/gdpr";
import {call, put, select} from "redux-saga/effects";

export function * gdpr() {

    let state: {
        gdpr: GDPR,
    } = yield select((appState: AppState) => ({
        gdpr: appState.gdpr,
    }));

    if (state.gdpr)
        return state.gdpr;

    const anonymous = window as any;

    const resolve = new Promise<GDPR>((res) => {
        let resolved = false;

        const timeout = setTimeout(() => {
            resolved = true;
            res({
                tcString: '',
                gdprApplies: 0,
            });
        }, 4000);

        switch (true) {
            case typeof anonymous['__tcfapi'] !== 'undefined':
                anonymous['__tcfapi']('getTCData', 2, (tcData: any) => {
                    clearTimeout(timeout);
                    if (!resolved) {
                        res(tcData);
                    }
                });
                break;
            case typeof anonymous['__cmp'] !== 'undefined':
                anonymous['__cmp']('getConsentData', null, (tcData: any) => {
                    clearTimeout(timeout);
                    if (!resolved)
                        res({
                            tcString: tcData ? tcData.consentData : "",
                            gdprApplies: tcData ? tcData.gdprApplies : 0,

                        });
                });
                break;
            default:
                clearTimeout(timeout);
                res({
                    tcString: '',
                    gdprApplies: 0,
                });
        }
    });

    state.gdpr = yield call(() => resolve);

    yield put<GDPRAction>({
        type: "GDPR",
        payload: state.gdpr,
    });
    return state.gdpr;

}